import api from "./api";

export const getFunnelCards = (funnelId) => {
    return api.get(`/funnels/${funnelId}/cards`);
};

export const createFunnelCard = (data) => {
    return api.post("/funnel-cards", data);
};

export const updateFunnelCard = (id, data) => {
    return api.put(`/funnel-cards/${id}`, data);
};

export const deleteFunnelCard = (id) => {
    return api.delete(`/funnel-cards/${id}`);
};

export const reorderFunnelCards = (funnelId, cards) => {
    return api.post(`/funnels/${funnelId}/cards/reorder`, { cards });
};
